"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestMetadata = exports.Route = exports.Channel = exports.Session = exports.Connection = void 0;
const bson_1 = require("bson");
const fflate_1 = require("fflate");
const cryptography_1 = require("./cryptography");
const utils_1 = require("./utils");
const { version } = require('../package.json');
const webcrypto = global.crypto;
class Connection {
    constructor(session, url = 'ws://localhost:8776') {
        this.RESEND_TIMEOUT = 2; // sec
        this.MAX_SEND_RETRIES = 3;
        this.session = session;
        this.url = url;
        this.tOffset = 0;
        this.awaitingAck = new Map();
        session.connections.push(this);
    }
    connect(retryCount = 0) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            if (this.websocket !== undefined) {
                this.websocket.close();
                this.websocket = undefined;
            }
            const WS = global.WebSocket;
            this.websocket = new WS(this.url);
            this.websocket.onerror = e => {
                if (retryCount < this.MAX_SEND_RETRIES) {
                    console.warn(`Failed connecting to ${this.url}. Retrying: ${retryCount + 1} of ${this.MAX_SEND_RETRIES}`);
                    setTimeout(() => __awaiter(this, void 0, void 0, function* () { return resolve(yield this.connect(retryCount + 1)); }), this.RESEND_TIMEOUT * 1000);
                }
                else {
                    reject(e);
                }
            };
            let queue = [];
            let waiting = [];
            let recv = () => new Promise((r) => queue.length > 0 ? r(queue.splice(0, 1)[0]) : waiting.push(r));
            this.websocket.onmessage = (m) => __awaiter(this, void 0, void 0, function* () {
                let a = typeof URL.createObjectURL === 'undefined' || typeof fetch === 'undefined' ?
                    m.data :
                    yield fetch(URL.createObjectURL(m.data)).then(r => r.arrayBuffer());
                let data = new Uint8Array(a);
                if (waiting.length > 0) {
                    for (var i in waiting) {
                        let res = waiting.pop();
                        res && res(data);
                    }
                }
                else {
                    queue.push(data);
                }
            });
            let challenge = yield recv();
            let signature = yield this.session.sessionKey.sign(challenge);
            let pk = new TextEncoder().encode(yield this.session.sessionKey.publicSerial());
            let sentChallenge = webcrypto.getRandomValues(new Uint8Array(32));
            let sentMetadata = new TextEncoder().encode(JSON.stringify({
                version: version
            }));
            this.websocket.send(new Uint8Array([
                ...signature,
                ...pk,
                ...sentChallenge,
                ...sentMetadata
            ]));
            this.tOffset = Date.now() / 1000 - (0, utils_1.bytesToInt)(challenge.slice(32, 36));
            let m = yield recv();
            let brokerId = new TextDecoder().decode(m.slice(64, 152));
            let publicKey = new cryptography_1.PublicKey('verify', brokerId);
            let metadata = JSON.parse(new TextDecoder().decode(m.slice(152)));
            // console.log(metadata)
            if (metadata.hasOwnProperty('entrypoint') && metadata.entrypoint) {
                this.entrypoint = Route.fromObject(metadata.entrypoint);
            }
            try {
                yield publicKey.verify(m.slice(0, 64), sentChallenge);
            }
            catch (e) {
                this.websocket.close();
                delete this.websocket;
                reject(e);
                return;
            }
            this.websocket.onmessage = (m) => __awaiter(this, void 0, void 0, function* () { return this.recv(m); });
            this.brokerId = brokerId;
            // this.websocket.onerror = console.warn;
            this.websocket.onerror = e => {
                console.warn(`Connection to ${this.url} closed: ${JSON.stringify(e, undefined, 2)}. Reconnecting...`);
                setTimeout(() => this.connect(), this.RESEND_TIMEOUT * 1000);
            };
            resolve(this);
        }));
    }
    recv(messageObj) {
        return __awaiter(this, void 0, void 0, function* () {
            let a = typeof URL.createObjectURL === 'undefined' || typeof fetch === 'undefined' ?
                messageObj.data :
                yield fetch(URL.createObjectURL(messageObj.data)).then(r => r.arrayBuffer());
            let message = new Uint8Array(a);
            let signature = message.slice(0, 64);
            let timestamp = (0, utils_1.bytesToInt)(message.slice(64, 68));
            if (this.session.checkNoRepeat(signature, timestamp + this.tOffset)) {
                let hLen = (0, utils_1.bytesToInt)(message.slice(68, 70));
                let pLen = (0, utils_1.bytesToInt)(message.slice(70, 73));
                let headers = JSON.parse(new TextDecoder().decode(message.slice(73, 73 + hLen)));
                let fullPayload = message.slice(73 + hLen, 73 + hLen + pLen);
                for (let i in headers) {
                    if (headers[i][0] === 'send') {
                        // console.log(headers)
                        let body = headers[i][1];
                        let publicKey = new cryptography_1.PublicKey('verify', body.source.session[0]);
                        try {
                            yield publicKey.verify(signature, message.slice(64, 73 + hLen + 65 + 32));
                            if (this.session.channels.has(body.destination.channel)) {
                                if (fullPayload[0] == 255) {
                                    // console.log('ACK');
                                    this.ack(body.source.session[0], (0, utils_1.b64encode)(fullPayload.slice(1, 65)));
                                }
                                else {
                                    let mid = fullPayload[0] == 0 ? signature : fullPayload.slice(1, 65);
                                    yield this.send([['send', { source: body.destination, destination: body.source }]], undefined, undefined, new Uint8Array([255, ...mid])); // Send ACK 
                                    let payload = fullPayload.slice(65 + 32);
                                    let hash = new Uint8Array(yield webcrypto.subtle.digest('SHA-256', payload));
                                    if (fullPayload.slice(65, 65 + 32).reduce((p, v, i) => p && v === hash[i], true)) {
                                        if (mid.reduce((p, v, i) => p && v === signature[i], true)
                                            || this.session.checkNoRepeat(mid, timestamp + this.tOffset)) {
                                            let channel = this.session.channels.get(body.destination.channel);
                                            channel && (yield channel.handleMessage(Route.fromObject(body.source), Route.fromObject(body.destination), payload, message.slice(0, 73 + hLen + 65 + 32)));
                                        }
                                    }
                                }
                            }
                        }
                        catch (e) {
                            console.error('On receive message error: ' + e);
                        }
                    }
                }
            }
        });
    }
    send(headers, payload = new Uint8Array(), bundleId, reply) {
        return new Promise((res, rej) => __awaiter(this, void 0, void 0, function* () {
            const encode = (messageId, retry) => __awaiter(this, void 0, void 0, function* () {
                let h = new TextEncoder().encode(JSON.stringify(headers));
                let r = reply ? reply : (retry && messageId ?
                    new Uint8Array([retry, ...(0, utils_1.b64decode)(messageId)]) :
                    new Uint8Array(65));
                let p = new Uint8Array(yield webcrypto.subtle.digest('SHA-256', payload));
                let m = new Uint8Array([
                    ...(0, utils_1.intToBytes)(Date.now() / 1000 - this.tOffset, 4),
                    ...(0, utils_1.intToBytes)(h.length, 2),
                    ...(0, utils_1.intToBytes)(payload.length + 32 + 65, 3),
                    ...h,
                    ...r,
                    ...p
                ]);
                let s = yield this.session.sessionKey.sign(m);
                return [s, new Uint8Array([...s, ...m, ...payload])];
            });
            let [s, mm] = yield encode();
            const expectAck = headers.map(([a, _]) => a).includes('send') && reply == undefined;
            const messageId = (0, utils_1.b64encode)(s);
            if (expectAck) {
                this.awaitingAck.set(messageId, [headers, res]);
            }
            for (let i in Array(this.MAX_SEND_RETRIES + 1).fill(0)) {
                if (this.websocket === undefined || this.websocket.readyState > 1) {
                    yield this.connect();
                }
                if (this.websocket !== undefined) {
                    this.websocket.send(mm);
                }
                ;
                if (!expectAck) {
                    res(undefined);
                    break;
                }
                yield new Promise(rr => setTimeout(rr, this.RESEND_TIMEOUT * 1000));
                if (!this.awaitingAck.has(messageId)) {
                    break;
                }
                else if (parseInt(i) === this.MAX_SEND_RETRIES) {
                    this.awaitingAck.delete(messageId);
                    rej(`Max sent retries reached`); // ${bundleId}`);
                }
                else {
                    [s, mm] = yield encode(messageId, parseInt(i));
                }
            }
        }));
    }
    ack(sourceId, messageId) {
        const [headers, resolve] = this.awaitingAck.get(messageId);
        // console.log(sourceId, messageId, headers)
        if (headers !== undefined) {
            for (let [action, content] of headers) {
                if (action === 'send' && content.destination.session[0] === sourceId) {
                    this.awaitingAck.delete(messageId);
                    resolve(undefined);
                }
            }
        }
    }
    clear(bundleId) { }
    close() {
        if (this.websocket) {
            this.websocket.onerror = () => undefined;
            this.websocket.close(1000);
        }
    }
}
exports.Connection = Connection;
class Session {
    constructor(sessionKey) {
        this.sessionKey = new cryptography_1.PrivateKey('sign', sessionKey);
        this.instanceId = (0, utils_1.b64encode)(Uint8Array.from(webcrypto.getRandomValues(new Uint8Array(6))));
        this.channels = new Map();
        this.connections = [];
        this.seenMessages = [new Set(), new Set(), 0];
        this.issuedTokens = new Map();
        this.targets = new Map();
        this.routes = new Map();
    }
    toString() {
        var _a;
        return `Session ${(_a = this.sessionKey.repr) === null || _a === void 0 ? void 0 : _a.slice(0, 4)} ${this.instanceId.slice(0, 2)}`;
    }
    checkNoRepeat(signature, timestamp) {
        let now = Date.now() / 1000;
        let lead = Math.floor(now / 60);
        if (this.seenMessages[2] != lead) {
            this.seenMessages[lead % 2] = new Set();
            this.seenMessages[2] = lead;
        }
        if (((now - 60 + 4) <= timestamp) && (timestamp < (now + 4))) {
            if (!this.seenMessages[0].has(signature) && !this.seenMessages[1].has(signature)) {
                this.seenMessages[lead % 2].add(signature);
                return true;
            }
        }
        return false;
    }
    issueToken(target, receiver, maxDepth) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenType;
            let prevToken;
            let asset;
            let token;
            if (target instanceof cryptography_1.Token) {
                tokenType = 'extension';
                prevToken = target;
                asset = target.signature;
            }
            else {
                tokenType = 'root';
                asset = target;
            }
            let cached = false;
            for (var tokens of this.issuedTokens.values()) {
                token = tokens[0];
                if (token.asset === asset &&
                    token.receiver === receiver &&
                    token.tokenType === tokenType &&
                    token.maxDepth === maxDepth) {
                    for (var j in this.connections) {
                        if (this.connections[j].brokerId && token.brokers.includes(this.connections[j].brokerId)) {
                            prevToken = tokens[1];
                            cached = true;
                        }
                    }
                }
            }
            if (!cached) {
                token = new cryptography_1.Token(yield this.sessionKey.publicSerial(), this.connections.map(c => c.brokerId), receiver, asset, tokenType || 'root', maxDepth);
                let signature = yield token.sign(this.sessionKey);
                this.issuedTokens.set(signature, [token, prevToken]);
            }
            return token && token.encode();
        });
    }
    extendRoute(route, receiver, maxDepth) {
        return __awaiter(this, void 0, void 0, function* () {
            let newTokenStr;
            if (route.session[0] === (yield this.sessionKey.publicSerial())) {
                newTokenStr = yield this.issueToken(route.channel, receiver, maxDepth);
            }
            else {
                for (var i in route.tokens) {
                    let token = yield cryptography_1.Token.decode(route.tokens[i]);
                    if (token.receiver === (yield this.sessionKey.publicSerial())) {
                        route.tokens = route.tokens.slice(0, parseInt(i) + 1);
                    }
                }
                let token = yield cryptography_1.Token.decode(route.tokens[route.tokens.length - 1]);
                newTokenStr = yield this.issueToken(token, receiver, maxDepth);
            }
            route.tokens.push(newTokenStr);
        });
    }
    clear(bundleId) {
        for (var i in this.connections) {
            let connection = this.connections[i];
            connection.clear(bundleId);
        }
    }
    send(headers, payload = new Uint8Array([]), bundleId) {
        return __awaiter(this, void 0, void 0, function* () {
            for (var i in this.connections) {
                let connection = this.connections[i];
                yield connection.send(headers, payload, bundleId);
            }
        });
    }
}
exports.Session = Session;
class Channel {
    constructor(session, channelKey, isPublic = false) {
        this.MAX_PAYLOAD_LEN = Math.pow(2, 19);
        this.MAX_COMPRESSION_LEN = Math.pow(2, 19);
        this.MAX_OUTBOX = Math.pow(2, 4);
        this.session = session;
        this.channelKey = new cryptography_1.PrivateKey('derive', channelKey);
        this.isPublic = isPublic;
        this.headerBuffer = [];
        this.chunks = new Map();
        this.messages = [];
        this.waiting = [];
        this.initLocks = [];
        this.then = this._then;
        this.channelKey.publicSerial().then(channelId => {
            this.session.channels.set(channelId, this);
            this.session.sessionKey.publicSerial().then(sessionId => {
                this.route = new Route(this.session.connections.map(c => c.brokerId), [sessionId, this.session.instanceId], channelId, []);
                for (var i in this.initLocks) {
                    this.initLocks[i](this);
                }
                this.initLocks = [];
            });
        });
    }
    toString() {
        var _a, _b;
        return `Channel ${(_a = this.session.sessionKey.repr) === null || _a === void 0 ? void 0 : _a.slice(0, 4)} ${this.session.instanceId.slice(0, 2)} - ${(_b = this.channelKey.repr) === null || _b === void 0 ? void 0 : _b.slice(0, 4)}`;
    }
    handleMessage(source, destination, rawPayload, proof) {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.validateTokenChain(source.session[0], destination.tokens)) {
                let sharedKey = new cryptography_1.SharedKey(this.channelKey, source.channel);
                let rawChunk = new Uint8Array(yield sharedKey.decrypt(rawPayload.slice(16), rawPayload.slice(0, 16)));
                let metadata = new RequestMetadata(this.session, source, [{ raw_payload: rawPayload, shared_key: sharedKey.key, proof: proof }]);
                let payloadSer = new Uint8Array();
                if ((0, utils_1.bytesToInt)(rawChunk.slice(0, 4)) === 0) {
                    payloadSer = rawChunk.slice(4);
                }
                else {
                    let i = (0, utils_1.bytesToInt)(rawChunk.slice(0, 2));
                    let n = (0, utils_1.bytesToInt)(rawChunk.slice(2, 4));
                    let mid = source.session[0] + (0, utils_1.bytesToInt)(rawChunk.slice(4, 8));
                    let chunk = rawChunk.slice(8);
                    if (!this.chunks.has(mid)) {
                        this.chunks.set(mid, new Map());
                    }
                    let chunksMap = this.chunks.get(mid);
                    chunksMap.set(i, [chunk, metadata]);
                    if (chunksMap.size === n) {
                        for (let ii = 0; ii < n; ii++) {
                            let ch = chunksMap.get(ii);
                            payloadSer = new Uint8Array([...payloadSer, ...ch[0]]);
                            if (ii != i) {
                                metadata.rawMessages.push(ch[1]);
                            }
                        }
                        this.chunks.delete(mid);
                    }
                    else {
                        return;
                    }
                }
                let payload;
                if (payloadSer[0] === 0) {
                    payload = (0, bson_1.deserialize)(payloadSer.slice(1));
                }
                else {
                    const ff = (0, fflate_1.unzlibSync)(payloadSer.slice(1));
                    payload = (0, bson_1.deserialize)(ff);
                }
                if (this.session.messageListener) {
                    this.session.messageListener(metadata);
                }
                // console.log(`<<< ${source} ${destination} ${Object.keys(payload)}`)
                if (this.telekinesis && this.telekinesis._handleRequest) {
                    this.telekinesis._handleRequest(this, metadata, payload);
                }
                else if (this.waiting.length > 0) {
                    let resolve = this.waiting.pop();
                    resolve && resolve([metadata, payload]);
                }
                else {
                    this.messages.push([metadata, payload]);
                }
            }
            else {
                console.error(`Invalid Tokens: ${source.session[0].slice(0, 4)} ${source.channel.slice(0, 4)} ||| ` +
                    `${destination.session[0].slice(0, 4)} ${destination.channel.slice(0, 4)} ` +
                    `[${destination.tokens}]`);
            }
        });
    }
    recv() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => this.messages.length > 0 ?
                resolve(this.messages.splice(0, 1)[0]) :
                this.waiting.push(resolve));
        });
    }
    listen() {
        function pushListenHeader(channel) {
            if (channel.route !== undefined) {
                let obj = {
                    brokers: channel.route.brokers,
                    session: channel.route.session,
                    channel: channel.route.channel,
                    is_public: channel.isPublic,
                };
                channel.headerBuffer.push(['listen', obj]);
            }
        }
        if (this.route === undefined) {
            this.initLocks.push(pushListenHeader);
        }
        else {
            pushListenHeader(this);
        }
        this.then = this._then;
        return this;
    }
    send(destination, payloadObj) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.route === undefined) {
                yield new Promise(r => this.initLocks.push(r));
            }
            if (this.route !== undefined) {
                function encryptSlice(payload, maxPayload, sharedKey, mid, n, i) {
                    return __asyncGenerator(this, arguments, function* encryptSlice_1() {
                        let chunk = new Uint8Array();
                        if (i < n) {
                            if (n === 1) {
                                chunk = new Uint8Array([...[0, 0, 0, 0], ...payload]);
                            }
                            else {
                                if (n > Math.pow(2, 16)) {
                                    throw `Payload size ${payload.length / Math.pow(2, 20)} MiB is too large`;
                                }
                                chunk = new Uint8Array([
                                    ...(0, utils_1.intToBytes)(i, 2),
                                    ...(0, utils_1.intToBytes)(n, 2),
                                    ...mid,
                                    ...payload.slice(i * maxPayload, (i + 1) * maxPayload)
                                ]);
                            }
                            let nonce = webcrypto.getRandomValues(new Uint8Array(16));
                            yield yield __await(new Uint8Array([...nonce, ...yield __await(sharedKey.encrypt(chunk, nonce))]));
                            yield __await(yield* __asyncDelegator(__asyncValues(yield __await(encryptSlice(payload, maxPayload, sharedKey, mid, n, i + 1)))));
                        }
                    });
                }
                function execute(channel, header, sliceGenerator, mid) {
                    var sliceGenerator_1, sliceGenerator_1_1;
                    var e_1, _a;
                    return __awaiter(this, void 0, void 0, function* () {
                        try {
                            for (sliceGenerator_1 = __asyncValues(sliceGenerator); sliceGenerator_1_1 = yield sliceGenerator_1.next(), !sliceGenerator_1_1.done;) {
                                let slice = sliceGenerator_1_1.value;
                                yield channel.execute(header, slice, mid);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (sliceGenerator_1_1 && !sliceGenerator_1_1.done && (_a = sliceGenerator_1.return)) yield _a.call(sliceGenerator_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    });
                }
                let sourceRoute = this.route.clone();
                yield this.session.extendRoute(sourceRoute, destination.session[0]);
                this.listen();
                let payload = new Uint8Array((0, bson_1.serialize)(payloadObj));
                if (payload.length < this.MAX_COMPRESSION_LEN) {
                    const ff = (0, fflate_1.zlibSync)(payload, {});
                    payload = new Uint8Array([255, ...ff]);
                }
                else {
                    payload = new Uint8Array([0, ...payload]);
                }
                let mid = webcrypto.getRandomValues(new Uint8Array(4));
                // console.log(`>>> ${this.route} ${destination} ${Object.keys(payloadObj)} ${mid}`)
                let sharedKey = new cryptography_1.SharedKey(this.channelKey, destination.channel);
                let header = [
                    'send', {
                        source: sourceRoute.toObject(),
                        destination: destination.toObject()
                    }
                ];
                let n = Math.floor((payload.length - 1) / this.MAX_PAYLOAD_LEN) + 1;
                let nTasks = Math.min(n, this.MAX_OUTBOX);
                let gen = encryptSlice(payload, this.MAX_PAYLOAD_LEN, sharedKey, mid, n, 0);
                try {
                    yield Promise.all(Array(nTasks).fill(0).map(() => new Promise(r => { execute(this, header, gen, mid).then(r); })));
                }
                catch (_a) {
                    this.session.clear(mid);
                }
                return new Promise(r => r(this));
            }
        });
    }
    execute(header, payload = new Uint8Array(), bundleId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.route === undefined) {
                yield new Promise(r => this.initLocks.push(r));
            }
            if (this.route !== undefined) {
                if (this.headerBuffer.length > 0 || header !== undefined) {
                    yield this.session.send(header !== undefined ? this.headerBuffer.concat([header]) : this.headerBuffer, payload, bundleId);
                    this.headerBuffer = [];
                }
            }
            this.then = undefined;
            return new Promise(r => r(this));
        });
    }
    _then(resolve) {
        if (this.headerBuffer.length === 0 && this.route !== undefined) {
            this.then = undefined;
            resolve(this);
        }
        else {
            this.execute().then(() => resolve(this));
        }
    }
    close() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            for (var i in this.session.connections) {
                let connection = this.session.connections[i];
                let obj = yield ((_a = this.route) === null || _a === void 0 ? void 0 : _a.toObject());
                yield connection.send([['close', obj]]);
            }
            for (var i in this.waiting) {
                this.waiting[i]([undefined, undefined]);
            }
        });
    }
    validateTokenChain(sourceId, tokens) {
        return __awaiter(this, void 0, void 0, function* () {
            let sessionId = yield this.session.sessionKey.publicSerial();
            if (this.isPublic || (sourceId === sessionId)) {
                return true;
            }
            if (tokens.length === 0) {
                return false;
            }
            let asset = yield this.channelKey.publicSerial();
            let lastReceiver = sessionId;
            let maxDepth = null;
            for (let depth in tokens) {
                let token;
                try {
                    token = (yield cryptography_1.Token.decode(tokens[depth]));
                }
                catch (e) {
                    if (e === 'Invalid Signature') {
                        return false;
                    }
                    throw e;
                }
                if ((token.asset === asset) && (token.issuer === lastReceiver)) {
                    if (token.issuer === sessionId) {
                        if (!this.session.issuedTokens.has(token.signature)) {
                            return false;
                        }
                    }
                    if (token.maxDepth) {
                        if (maxDepth === null || ((token.maxDepth + depth) < maxDepth)) {
                            maxDepth = token.maxDepth + depth;
                        }
                    }
                    if (maxDepth === null || (depth < maxDepth)) {
                        lastReceiver = token.receiver;
                        asset = token.signature;
                        if (lastReceiver === sourceId) {
                            return true;
                        }
                        continue;
                    }
                }
                return false;
            }
            return false;
        });
    }
}
exports.Channel = Channel;
class Route {
    constructor(brokers, session, channel, tokens, parentChannel) {
        this.brokers = brokers;
        this.session = session;
        this.channel = channel;
        this.tokens = tokens;
        this._hash = this.session.join('') + this.channel;
        this._parentChannel = parentChannel;
    }
    toObject() {
        return {
            brokers: this.brokers,
            session: this.session,
            channel: this.channel,
            tokens: this.tokens,
        };
    }
    toString() {
        return `Route ${this.session[0].slice(0, 4)} ${this.session[1].slice(0, 2)} - ${this.channel.slice(0, 4)}`;
    }
    clone() {
        return Route.fromObject(this.toObject());
    }
    validateTokenChain(receiver) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.session[0] !== receiver) {
                if (!(this.tokens.length > 0)) {
                    throw 'Invalid token chain 0';
                }
                let prevToken = undefined;
                for (let i in this.tokens) {
                    let token = yield cryptography_1.Token.decode(this.tokens[i]);
                    prevToken = prevToken || token;
                    if ((i === '0' && (!(token.asset == this.channel) || !(token.tokenType == 'root') || !(token.issuer == this.session[0]))) ||
                        (i !== '0') && (!(token.issuer === prevToken.receiver) || !(token.asset === prevToken.signature) || !(token.tokenType === 'extension')) ||
                        (i === this.tokens.length.toString() && token.receiver !== receiver)) {
                        // console.log(i, token, prevToken, this, receiver)
                        // console.log(!(token.issuer === prevToken.receiver), !(token.asset === prevToken.signature) || !(token.tokenType === 'extension'), token.receiver !== receiver)
                        throw 'Invalid token chain';
                    }
                    if (token.receiver === receiver) {
                        break;
                    }
                }
            }
            return true;
        });
    }
    static fromObject(obj) {
        return new Route(obj.brokers, obj.session, obj.channel, obj.tokens);
    }
}
exports.Route = Route;
class RequestMetadata {
    constructor(session, caller, rawMessages) {
        this._session = session;
        this.sessionPublicKey = "";
        session.sessionKey.publicSerial().then((s) => { this.sessionPublicKey = s; });
        this.caller = caller;
        this.rawMessages = rawMessages;
    }
}
exports.RequestMetadata = RequestMetadata;
//# sourceMappingURL=client.js.map